export const BASE_CLASS_NAME = 'select' as const;
